import { render, staticRenderFns } from "./quessionnaireSelect.vue?vue&type=template&id=652d621a&scoped=true&"
import script from "./quessionnaireSelect.vue?vue&type=script&lang=js&"
export * from "./quessionnaireSelect.vue?vue&type=script&lang=js&"
import style0 from "./quessionnaireSelect.vue?vue&type=style&index=0&id=652d621a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d621a",
  null
  
)

export default component.exports